import * as React from "react";
import type { SVGProps } from "react";

interface Minutes5Props extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Minutes5 = ({ cancelled = false, ...props }: Minutes5Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.93} fill="#FFF" rx={8.09} ry={8.14} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.99-.38A1.32 1.32 0 0 1 12.3.8c0 .47-.13.82-.35 1.07-.24.28-.58.44-.96.44l-.38.52a9.88 9.88 0 0 1 8.77 9.74 9.88 9.88 0 0 1-9.88 9.8 9.88 9.88 0 0 1-9.88-9.8A9.88 9.88 0 0 1 8.4 2.83V2.3c-.74 0-1.07-.15-1.31-.39a1.37 1.37 0 0 1 0-1.9c.23-.24.56-.4.93-.4H11ZM9.5 4.97a7.67 7.67 0 0 0-7.66 7.6 7.67 7.67 0 0 0 13.08 5.38 7.55 7.55 0 0 0 0-10.75A7.67 7.67 0 0 0 9.5 4.97Z"
        />
      </g>
      <path
        fill="#FF1212"
        fillRule="nonzero"
        d="M11.8 19.09a3.48 3.48 0 0 1-2.4-.93c-.25-.23-.36-.46-.33-.7a.82.82 0 0 1 .42-.59c.25-.16.47-.21.67-.16.2.06.43.17.68.36a1.54 1.54 0 0 0 .96.31c.53 0 .92-.15 1.18-.46a2 2 0 0 0 .38-1.31c0-.63-.12-1.07-.34-1.33a1.14 1.14 0 0 0-.9-.4c-.24 0-.45.04-.64.13-.23.12-.43.23-.59.35a1.1 1.1 0 0 1-.64.17c-.6 0-.91-.33-.91-.99V9.49q0-.99.99-.99h3.45q.99 0 .99.81c0 .55-.33.82-1 .82h-2.65v2.46a1.8 1.8 0 0 1 1.04-.34c.56 0 1.06.12 1.51.37.45.24.81.61 1.08 1.1.27.5.4 1.13.4 1.89 0 1.11-.3 1.97-.92 2.57-.61.6-1.42.91-2.43.91"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Minutes5;
